/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import url from '@/services/ApiServices/apiUrls'
import { store } from '@/store/store'

export const orderApi = new Vue({
	methods: {
		getAllPaymentOptions () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getAllPaymentOptionsUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		orderProduct () {
			const orderDetails = {}
			orderDetails.address_id = store.getters['user/getSelectedAddressId']
			// orderDetails.payment_method = payMode;
			orderDetails.country_code =
				store.getters['siteData/getSelectedCountry'].country_code
			orderDetails.redeem_coin = store.getters['user/getCoinDetails'].coinNo
			orderDetails.cartData = {}
			if (store.getters['buynow/getOrderBuyNowProduct'].length > 0) {
				orderDetails.cartData.cartProductDetails =
					store.getters['buynow/getOrderBuyNowProduct']
			} else {
				orderDetails.cartData.cartProductDetails =
					store.getters['cart/getOrderCart']
				const orderData = store.getters['cart/getCartProducts']
				store.dispatch('order/setOrderProducts', orderData)
			}
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.orderProductUrl, orderDetails)
					.then(res => {
						store.dispatch('user/setOrderData', res.data)
						if (
							store.getters['buynow/getBuyNowProduct'] &&
							store.getters['buynow/getBuyNowProduct'].length > 0
						) {
							store.dispatch(
								'charges/setShippingCharge',
								res.data.shipping_fee / store.getters['buynow/getBuyNowProductCount']
							)
							store.dispatch(
								'charges/setTax',
								res.data.tax / store.getters['buynow/getBuyNowProductCount']
							)
							store.dispatch('buynow/updateGiftCardQuantity')
						} else {
							store.dispatch(
								'charges/setShippingCharge',
								res.data.shipping_fee / store.getters['cart/getCartTotalQuantity']
							)
							store.dispatch(
								'charges/setTax',
								res.data.tax / store.getters['cart/getCartTotalQuantity']
							)
							store.dispatch('cart/updateGiftCardCartQuantity')
						}
						resolve(res)
					})
					.catch(e => {
						if (
							e.status === 400 &&
							(e.data.message === 'You are already use this promo code' ||
								e.data.message === 'The validity of promo code is expired')
						) {
							store.dispatch('user/setPromoCodeData', '')
							store.dispatch('buynow/updateGiftCardQuantity')
							store.dispatch('cart/updateGiftCardCartQuantity')
						}
						Vue.toasted.show(`${e.body.message}`, {
							icon: 'exclamation-circle'
						})
						reject(e)
					})
			})
		},
		getOrders () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getOrdersUrl)
					.then(res => {
						store.dispatch('order/setTotalOrderData', res.data)
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		trackOrder (orderNumber, token) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.trackOrderUrl}${orderNumber}&token=${token}`
				this.$http
					.get(getUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		sendOtp (phoneNo) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.sendOtpUrl}${phoneNo}`
				this.$http
					.get(getUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		sendOrderOTPEmail (email) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.sendOrderOTPEmailUrl, {
						email
					})
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		verifyOtp (otp) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.verifyOtpUrl}${otp}`
				this.$http
					.post(postUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		verifyOrderOTPEmail (otp) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.verifyOrderOTPEmailUrl + otp)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		stripePayment (token) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.stripePaymentUrl, token)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						Vue.toasted.show(`${e.body.message}`, {
							icon: 'exclamation-circle'
						})
						reject(e)
					})
			})
		},
		addPaymentCard (cardData) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.addStripeCardUrl, cardData)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getAllCards () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getAllStripeCards)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		deletePaymentCard (cardId) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.deleteStripeCardUrl + cardId)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		orderCharge (paymentMethod = 'CARD', cardId = '', accountNumber = '') {
			let totalAmountToBePaid = 0
			let currencyName = ''
			let orderNumber = ''
			let paymentGatewayId = ''
			let promoCode = ''
			let giftCardNumber = ''
			let giftCardPin = ''
			if (
				store.getters['user/getGiftCardDetails'] &&
				store.getters['user/getGiftCardDetails'].gift_cards
			) {
				store.getters['user/getGiftCardDetails'].gift_cards.forEach(product => {
					totalAmountToBePaid += product.subtotal
				})
				currencyName = store.getters['user/getGiftCardDetails'].base_currency
				orderNumber = store.getters['user/getGiftCardDetails'].order_number
				paymentGatewayId = 'razorpay'
			} else if (
				store.getters['vendor/getSubscriptionOrderData'] &&
				store.getters['vendor/getSubscriptionOrderData'].order_number
			) {
				totalAmountToBePaid =
					store.getters['vendor/getSubscriptionOrderData'].total_amount
				currencyName =
					store.getters['vendor/getSubscriptionOrderData'].base_currency
				orderNumber = store.getters['vendor/getSubscriptionOrderData'].order_number
				paymentGatewayId = 'razorpay'
			} else {
				// store.getters['user/getOrderData'].cartProductDetails
				//   .forEach((product) => {
				//     totalAmountToBePaid += product.subtotal;
				//   });
				giftCardNumber = store.getters['user/getGiftCardNo']
				giftCardPin = store.getters['user/getGiftCardPin']
				promoCode = store.getters['user/getPromoCode'].promo_code
				totalAmountToBePaid = store.getters['cart/getcartTotal']
				if (store.getters['buynow/getOrderBuyNowProduct'].length > 0) {
					totalAmountToBePaid = store.getters['buynow/getBuyNowTotal']
				}
				currencyName = store.getters['siteData/getSelectedCountry'].currency_name
				orderNumber = store.getters['user/getOrderData'].order_number
				paymentGatewayId = store.getters['siteData/getPaymentGatewayId']
			}
			const orderCharge = {
				amount: totalAmountToBePaid,
				currency_code: currencyName,
				order_number: orderNumber,
				payment_gateway_id: paymentGatewayId,
				payment_method: paymentMethod,
				card_number: cardId,
				description: 'Payment',
				promo_code: promoCode,
				gift_card: giftCardNumber,
				gift_card_pin: giftCardPin,
				account_number: accountNumber
			}
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.orderChargeUrl, orderCharge)
					.then(res => {
						// store.dispatch('user/clearGiftAmountData');
						// store.dispatch('user/clearGiftCardNo');
						// store.dispatch('user/clearGiftCardPin');
						// store.dispatch('user/clearCoinRedeemData');
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		razorPayPaymentCreate () {
			let totalAmountToBePaid = 0
			store.getters['user/getOrderData'].cartProductDetails.forEach(product => {
				totalAmountToBePaid += product.subtotal
			})
			const currencyName =
				store.getters['siteData/getSelectedCountry'].currency_name
			const orderNumber = store.getters['user/getOrderData'].order_number
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.razorPayPaymentCreateUrl, {
						type: 'link',
						view_less: '1',
						amount: totalAmountToBePaid,
						currency: currencyName,
						description: 'Payment link for this purpose',
						order_number: orderNumber,
						chosen_gateway: 'razorpay'
					})
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		verifyRazorPayPayment () {
			const razorPayOrderId =
				store.getters['siteData/getPaymentId'].razorpay_order_id
			const razorPayPaymentId =
				store.getters['siteData/getPaymentId'].razorpay_payment_id
			const razorPaySignature =
				store.getters['siteData/getPaymentId'].razorpay_signature
			const gatewayId = 'razorpay'
			return new Promise((resolve, reject) => {
				this.$http
					.post(url.verifyRazorPayPaymentUrl, {
						razorpay_payment_id: razorPayPaymentId,
						razorpay_order_id: razorPayOrderId,
						razorpay_signature: razorPaySignature,
						gateway_id: gatewayId
					})
					.then(res => {
						store.dispatch('user/clearGiftAmountData')
						// store.dispatch('user/clearGiftCardNo');
						// store.dispatch('user/clearGiftCardPin');
						// store.dispatch('user/clearCoinRedeemData');
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		razorPayPaymentFinalize () {
			const orderNumber = store.getters['user/getOrderData'].order_number
			const paymentId = store.getters['siteData/getPaymentId']
			const postUrl = `${
				url.razorPayPaymentFinalizeUrl
			}${orderNumber}&payment_id=${paymentId}`
			return new Promise((resolve, reject) => {
				this.$http
					.post(postUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getReviewStatus (orderNumber, productId) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.getReviewStatus}?order_number=${orderNumber}`
				this.$http
					.post(postUrl, { product_id: productId })
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getOrderStatus (productId) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.getOrderStatus}`
				this.$http
					.post(postUrl, { product_id: productId })
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		createGiftCard (giftData) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.giftCard}`
				this.$http
					.post(postUrl, giftData)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		giftCardValidate (cardData) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.giftCardValidation}?card_id=${
					cardData.giftCardNumber
				}&pin=${cardData.giftCardPin}`
				this.$http
					.get(getUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						Vue.toasted.show(`${e.body.message}`, { icon: 'exclamation-circle' })
						store.dispatch('user/clearGiftCardNo')
						store.dispatch('user/clearGiftCardPin')
						// this.clearGiftCardNo();
						// this.clearGiftCardPin();
						reject(e)
					})
			})
		},
		orderReturn (orderNumber, productId, vendorId, returnDetails) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.orderReturnUrl}`
				this.$http
					.post(postUrl, {
						order_number: orderNumber,
						product_id: productId,
						vendor_id: vendorId,
						reason_for_return: returnDetails
					})
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		async checkVendorAvailability () {
			const allAvailableVendors =
				store.getters['productselected/getAllAvailableVendors']
			const selectedCountry = store.getters['user/getSelectedAddress'].country
			const selectedDistrict = store.getters['user/getSelectedAddress'].locality
			const selectedState = store.getters['user/getSelectedAddress'].state
			const selectedPincode = store.getters['user/getSelectedAddress'].pinCode
			const postUrl = `${url.checkVendorAvailabilityUrl}`
			try {
				const availableVendorList = await this.$http.post(postUrl, {
					vendors: allAvailableVendors,
					current_address: {
						country: selectedCountry,
						state: selectedState,
						district: selectedDistrict,
						pin_code: selectedPincode
					}
				})
				store.dispatch(
					'productselected/setAvailableVendorsData',
					availableVendorList
				)
				return availableVendorList
			} catch (err) {
				store.dispatch('productselected/setAvailableVendorsData', null)
				throw err
			}
		}
	}
})
